import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4328E7',
    },
    secondary: {
      main: '#24BF9B',
    },
    tertiary: {
      main: "#FCF1E3"
    },
    background: {
      main: '#fff6dc'
    },
    text:{
      primary:"#100F0D",
      secondary:"#525456"
    }
  },
  typography:{
    fontFamily:"Montserrat",
    fontWeight:"500",
    body1:{
      fontSize:"1rem"
    },
    body2:{
      fontSize:"1.25rem"
    }
  }
});

export default theme;
